// CNPJ alfanumérico (a partir de 2026): 12 primeiras posições aceitam 0-9 e A-Z,
// os 2 dígitos verificadores continuam numéricos. Valor de cada caractere = código ASCII - 48.
const CNPJ_ALFANUMERICO = /^[0-9A-Z]{12}\d{2}$/;
const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const calcularDigito = (base: string, pesos: number[]): number => {
  const soma = pesos.reduce((acc, peso, i) => acc + (base.charCodeAt(i) - 48) * peso, 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

export function cnpjValidator(cnpj: string): boolean {
  cnpj = cnpj.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();

  if (!CNPJ_ALFANUMERICO.test(cnpj)) {
    return false;
  }

  if (/^(.)\1+$/.test(cnpj)) {
    return false;
  }

  const digitoVerificador1 = calcularDigito(cnpj, PESOS_DV1);
  const digitoVerificador2 = calcularDigito(cnpj, PESOS_DV2);

  return cnpj.endsWith(`${digitoVerificador1}${digitoVerificador2}`);
}
